import React from "react";
import { useTranslation } from "react-i18next";
import "./EAAvailabilityDots.scss";

interface IProps {
  /** Udział wolnych miejsc, 0–100. */
  percentageFree: number;
  /** Podpowiedź po najechaniu. Wyłącz, gdy rodzic ma już własny tooltip. */
  labelled?: boolean;
}

type AvailabilityLevel = "none" | "low" | "medium" | "high";

const LEVEL_LABEL_KEY: Record<AvailabilityLevel, string> = {
  none: "dostepnosc_brak",
  low: "dostepnosc_mala",
  medium: "dostepnosc_srednia",
  high: "dostepnosc_duza",
};

/** Te same progi co dotychczas w grafiku godzinowym. Zero to osobny stan „brak”. */
function availabilityLevel(percentageFree: number): AvailabilityLevel {
  if (percentageFree <= 0) return "none";
  if (percentageFree < 20) return "low";
  if (percentageFree < 60) return "medium";
  return "high";
}

const FILLED_DOTS: Record<AvailabilityLevel, number> = {
  none: 0,
  low: 1,
  medium: 2,
  high: 3,
};

const EAAvailabilityDots: React.FC<IProps> = ({ percentageFree, labelled = true }) => {
  const { t } = useTranslation();
  const level = availabilityLevel(percentageFree);
  const label = t(LEVEL_LABEL_KEY[level]);
  const filled = FILLED_DOTS[level];

  return (
    <span className="availability-dots" title={labelled ? label : undefined} aria-label={label}>
      {Array.from({ length: 3 }, (_, index) => (
        <span
          key={index}
          className={
            index < filled ? `availability-dots__dot availability-dots__dot--${level}` : "availability-dots__dot"
          }
        />
      ))}
    </span>
  );
};

export default EAAvailabilityDots;
